import React, { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

interface RoleProtectedRouteProps {
  allowedRoles: string[];
  children: ReactElement;
}

const RoleProtectedRoute = ({
  allowedRoles,
  children,
}: RoleProtectedRouteProps): ReactElement | null => {
  const { user, isLoading } = useAuth();

  // ⏳ Loading
  if (isLoading) {
    return null;
  }

  // 🔒 Not logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 🚫 Role not allowed
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/403" replace />;
  }

  // ✅ Allowed
  return children;
};

export default RoleProtectedRoute;
